export default "__VITE_ASSET__51663971__"